// extracted by mini-css-extract-plugin
export default {"startPageContainer":"start-page_startPageContainer__ed+vp"};